import React from "react";
import PropTypes from "prop-types";

export class SystemReport extends React.Component {
  render() {
    const { installationData, installationType, settings } = this.props;

    const installationTypes = (settings && settings.installationTypes) || {};
    const installationTypeData = installationType && installationTypes[installationType];
    const formGroupings = installationTypeData && installationTypeData.formGroupings && installationTypeData.formGroupings.systemReport;
    const formFields = (installationTypeData && installationTypeData.forms && installationTypeData.forms.systemReport) || {};

    if (!formGroupings || !formGroupings.sections) {
      return <div>No system report configuration available</div>;
    }

    return (
      <div style={{ padding: 16 }}>
        {formGroupings.sections.map((sectionItem, sectionIndex) => (
          <div key={sectionIndex} style={{ marginBottom: sectionIndex < formGroupings.sections.length - 1 ? 24 : 0 }}>
            <h3 style={{ marginBottom: 16, fontSize: 18, fontWeight: "bold" }}>{sectionItem.label}</h3>
            <div style={{ borderTop: "1px solid #e0e0e0", paddingTop: 8 }}>
              {sectionItem.fields.map((fieldName, fieldIndex) => {
                const fieldDef = formFields[fieldName];
                const fieldLabel = (fieldDef && fieldDef.label) || fieldName;
                const fieldValue = installationData && installationData[fieldName];
                const isLastField = fieldIndex === sectionItem.fields.length - 1;

                return (
                  <div
                    key={fieldIndex}
                    style={{
                      padding: 16,
                      borderBottom: isLastField ? "none" : "1px solid #e0e0e0",
                      display: "flex",
                    }}
                  >
                    <div style={{ minWidth: 200, fontWeight: "bold" }}>
                      {fieldLabel}
                    </div>
                    <div style={{ color: "#666" }}>
                      {fieldValue !== undefined && fieldValue !== null ? fieldValue : "N/A"}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    );
  }
}

SystemReport.propTypes = {
  installationData: PropTypes.object,
  installationType: PropTypes.string,
  settings: PropTypes.object,
};

export default SystemReport;

